import {DefaultRepository} from "./index";
import axios from "axios";
import {ManagementUnit} from "../model/Client";

class ManagementUnitRepository extends DefaultRepository {

    create(clientId: string, unitType: string, unitId: string, unitName: string, userId: string) {
        return axios.post(`${this.HOST}/management-units`, {
            client_id: clientId,
            unit_type: unitType,
            unit_id: unitId,
            unit_name: unitName,
            user_id: userId
        });
    }

    find(clientId: string) {
        return axios.get(`${this.HOST}/management-units`, {
            params: {
                client_id: clientId
            }
        });
    }

    findOwn(clientId: string) {
        return axios.get(`${this.HOST}/management-units/own`, {
            params: {
                client_id: clientId
            }
        });
    }

    read(managementUnitId: string) {
        return axios.get(`${this.HOST}/management-units/${managementUnitId}`);
    }

    update(managementUnitId: string, managementUnit: ManagementUnit) {
        return axios.put(`${this.HOST}/management-units/${managementUnitId}`, managementUnit);
    }

    sync(clientId?: string) {
        return axios.post(`${this.HOST}/management-units/sync`, {
            client_id: clientId
        });
    }
}

export default new ManagementUnitRepository();